// 菜单 侧边栏
export default [{
    path: '/index',
    title: '首页',
    icon: 'home'
  },
  {
    title: '交易管理',
    icon: 'folder-o',
    children: [{
        path: '/transaction',
        title: '全部交易'
      },
      {
        path: '/tx-usdt',
        title: 'USDT交易'
      },
      {
        path: '/tx-nos',
        title: 'NOS交易'
      },
    ]
  },
  {
    title: '映射管理',
    icon: 'folder-o',
    children: [{
      path: '/mapping',
      title: '映射列表'
    }, ]
  },
  {
    title: '手续费管理',
    icon: 'folder-o',
    children: [{
      path: '/fee',
      title: '手续费列表'
    }, ]
  },
  {
    title: '交易时间管理',
    icon: 'folder-o',
    children: [{
      path: '/time',
      title: '交易时间列表'
    }, ]
  },
  {
    title: '系统管理',
    icon: 'folder-o',
    children: [{
      path: '/admin',
      title: '管理员列表'
    }, ]
  },
  {
    title: '资产查询工具',
    icon: 'folder-o',
    children: [{
      path: '/balanceTool',
      title: '资产查询工具'
    }, ]
  },
]